function PlanJ({ ...props }) {
	return (
		<g {...props} id="unit-j">
			<g id="furniture">
				<polyline
					points="338.82 835.45 336.31 835.45 336.31 830.48 338.82 830.48 338.82 835.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="659.8"
					y1="436.76"
					x2="791.04"
					y2="436.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.26"
					y1="474.51"
					x2="756.22"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.59"
					y1="474.51"
					x2="746.55"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.93"
					y1="474.51"
					x2="736.89"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.27"
					y1="474.51"
					x2="727.23"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.61"
					y1="474.51"
					x2="717.56"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.94"
					y1="474.51"
					x2="707.9"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.28"
					y1="474.51"
					x2="698.24"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.62"
					y1="474.51"
					x2="688.58"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.8"
					y1="455.08"
					x2="659.8"
					y2="449.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.8"
					y1="445.42"
					x2="659.8"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.8"
					y1="439.28"
					x2="665.63"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.25"
					y1="439.28"
					x2="675.29"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.91"
					y1="439.28"
					x2="684.95"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.58"
					y1="439.28"
					x2="694.62"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.24"
					y1="439.28"
					x2="704.28"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.9"
					y1="439.28"
					x2="713.94"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.56"
					y1="439.28"
					x2="723.61"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.23"
					y1="439.28"
					x2="733.27"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.89"
					y1="439.28"
					x2="742.93"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.55"
					y1="439.28"
					x2="752.59"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.22"
					y1="439.28"
					x2="762.26"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.88"
					y1="439.28"
					x2="771.92"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.54"
					y1="439.28"
					x2="781.58"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.21"
					y1="439.28"
					x2="791.04"
					y2="439.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.04"
					y1="439.28"
					x2="791.04"
					y2="445.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.04"
					y1="449.04"
					x2="791.04"
					y2="455.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.23"
					y1="606.83"
					x2="224.23"
					y2="908.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.79"
					y1="847.76"
					x2="284.63"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="847.76"
					x2="284.63"
					y2="606.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.79"
					y1="877.96"
					x2="329.74"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="326.12"
					y1="877.96"
					x2="320.08"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.46"
					y1="877.96"
					x2="310.41"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.79"
					y1="877.96"
					x2="300.75"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.13"
					y1="877.96"
					x2="291.09"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.47"
					y1="877.96"
					x2="281.43"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.8"
					y1="877.96"
					x2="271.76"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.14"
					y1="877.96"
					x2="262.1"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.48"
					y1="877.96"
					x2="254.43"
					y2="877.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="682.96"
					x2="592.93"
					y2="645.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="645.22"
					x2="791.04"
					y2="645.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.29"
					y1="682.96"
					x2="766.26"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.63"
					y1="682.96"
					x2="756.59"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.97"
					y1="682.96"
					x2="746.93"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.3"
					y1="682.96"
					x2="737.27"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.64"
					y1="682.96"
					x2="727.6"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.98"
					y1="682.96"
					x2="717.94"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.32"
					y1="682.96"
					x2="708.28"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.65"
					y1="682.96"
					x2="698.61"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.99"
					y1="682.96"
					x2="688.95"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.33"
					y1="682.96"
					x2="679.29"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.67"
					y1="682.96"
					x2="669.62"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666"
					y1="682.96"
					x2="659.96"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.34"
					y1="682.96"
					x2="650.3"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.68"
					y1="682.96"
					x2="640.64"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.01"
					y1="682.96"
					x2="630.97"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.35"
					y1="682.96"
					x2="621.31"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.69"
					y1="682.96"
					x2="611.65"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.02"
					y1="682.96"
					x2="601.99"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.36"
					y1="682.96"
					x2="592.9"
					y2="682.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.9"
					y1="682.96"
					x2="592.9"
					y2="676.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.9"
					y1="673.2"
					x2="592.9"
					y2="667.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.9"
					y1="663.53"
					x2="592.9"
					y2="657.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.9"
					y1="653.87"
					x2="592.9"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.9"
					y1="647.73"
					x2="598.36"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.99"
					y1="647.73"
					x2="608.02"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.65"
					y1="647.73"
					x2="617.69"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.31"
					y1="647.73"
					x2="627.35"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.97"
					y1="647.73"
					x2="637.01"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.64"
					y1="647.73"
					x2="646.68"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.3"
					y1="647.73"
					x2="656.34"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.96"
					y1="647.73"
					x2="666"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.62"
					y1="647.73"
					x2="675.67"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.29"
					y1="647.73"
					x2="685.33"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.95"
					y1="647.73"
					x2="694.99"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.61"
					y1="647.73"
					x2="704.65"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.28"
					y1="647.73"
					x2="714.32"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.94"
					y1="647.73"
					x2="723.98"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.6"
					y1="647.73"
					x2="733.64"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.27"
					y1="647.73"
					x2="743.3"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.93"
					y1="647.73"
					x2="752.97"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.59"
					y1="647.73"
					x2="762.63"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.26"
					y1="647.73"
					x2="772.29"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.92"
					y1="647.73"
					x2="781.96"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.58"
					y1="647.73"
					x2="791.04"
					y2="647.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.04"
					y1="647.73"
					x2="791.04"
					y2="653.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.04"
					y1="657.5"
					x2="791.04"
					y2="663.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="715.65 597.49 715.65 529.55 783.6 529.55 783.6 597.49 715.65 597.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="392.59 54.05 338.68 54.05 338.68 59.5 392.59 59.5 392.59 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="336.69 53.55 394.58 53.55 394.58 54.05 336.69 54.05 336.69 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="336.69"
					y1="53.55"
					x2="394.58"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.58"
					y1="53.55"
					x2="394.58"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.58"
					y1="54.05"
					x2="336.69"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.69"
					y1="54.05"
					x2="336.69"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.59"
					y1="59.5"
					x2="338.68"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.68"
					y1="54.05"
					x2="392.59"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="397.05 59.5 392.59 59.5 392.59 54.05 397.05 54.05 397.05 59.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="397.05"
					y1="59.5"
					x2="392.59"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.59"
					y1="59.5"
					x2="392.59"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.59"
					y1="54.05"
					x2="397.05"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.05"
					y1="54.05"
					x2="397.05"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="334.22 54.05 338.68 54.05 338.68 59.5 334.22 59.5 334.22 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="334.22"
					y1="54.05"
					x2="338.68"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.68"
					y1="54.05"
					x2="338.68"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.68"
					y1="59.5"
					x2="334.22"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.22"
					y1="59.5"
					x2="334.22"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.59"
					y1="55.04"
					x2="338.68"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="399.03 59 397.05 59 397.05 54.05 394.58 54.05 394.58 53.55 399.03 53.55 399.03 59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="399.03"
					y1="59"
					x2="397.05"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.05"
					y1="59"
					x2="397.05"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.05"
					y1="54.05"
					x2="394.58"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.58"
					y1="54.05"
					x2="394.58"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.58"
					y1="53.55"
					x2="399.03"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.03"
					y1="53.55"
					x2="399.03"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.24 53.55 336.69 53.55 336.69 54.05 334.22 54.05 334.22 59 332.24 59 332.24 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.24"
					y1="53.55"
					x2="336.69"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.69"
					y1="53.55"
					x2="336.69"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.69"
					y1="54.05"
					x2="334.22"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.22"
					y1="54.05"
					x2="334.22"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.22"
					y1="59"
					x2="332.24"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.24"
					y1="59"
					x2="332.24"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="329.72 55.04 329.72 57.55 238.1 57.55 238.1 55.04 329.72 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="329.72"
					y1="55.04"
					x2="329.72"
					y2="57.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.72"
					y1="57.55"
					x2="238.1"
					y2="57.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.1"
					y1="57.55"
					x2="238.1"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.1"
					y1="55.04"
					x2="329.72"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="399.03 55.04 404.06 55.04 404.06 70.14 399.03 70.14 399.03 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="404.06"
					y1="55.04"
					x2="399.03"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.06"
					y1="70.14"
					x2="404.06"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.03"
					y1="70.14"
					x2="404.06"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.03"
					y1="55.04"
					x2="399.03"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="327.2 55.04 332.24 55.04 332.24 70.14 327.2 70.14 327.2 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.24"
					y1="55.04"
					x2="327.2"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.24"
					y1="70.14"
					x2="332.24"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.2"
					y1="70.14"
					x2="332.24"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.2"
					y1="55.04"
					x2="327.2"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="235.58 55.04 240.61 55.04 240.61 70.14 235.58 70.14 235.58 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="240.61"
					y1="55.04"
					x2="235.58"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.61"
					y1="70.14"
					x2="240.61"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.58"
					y1="70.14"
					x2="240.61"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.58"
					y1="55.04"
					x2="235.58"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="570.83 54.05 517.27 54.05 517.27 59.5 570.83 59.5 570.83 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="515.29 53.55 572.81 53.55 572.81 54.05 515.29 54.05 515.29 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="515.29"
					y1="53.55"
					x2="572.81"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.81"
					y1="53.55"
					x2="572.81"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.81"
					y1="54.05"
					x2="515.29"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.29"
					y1="54.05"
					x2="515.29"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.83"
					y1="59.5"
					x2="517.27"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.27"
					y1="54.05"
					x2="570.83"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="575.29 59.5 570.83 59.5 570.83 54.05 575.29 54.05 575.29 59.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="575.29"
					y1="59.5"
					x2="570.83"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.83"
					y1="59.5"
					x2="570.83"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.83"
					y1="54.05"
					x2="575.29"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.29"
					y1="54.05"
					x2="575.29"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="512.81 54.05 517.27 54.05 517.27 59.5 512.81 59.5 512.81 54.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="512.81"
					y1="54.05"
					x2="517.27"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.27"
					y1="54.05"
					x2="517.27"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.27"
					y1="59.5"
					x2="512.81"
					y2="59.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.81"
					y1="59.5"
					x2="512.81"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="570.83"
					y1="55.04"
					x2="517.27"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="577.27 59 575.29 59 575.29 54.05 572.81 54.05 572.81 53.55 577.27 53.55 577.27 59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="577.27"
					y1="59"
					x2="575.29"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.29"
					y1="59"
					x2="575.29"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.29"
					y1="54.05"
					x2="572.81"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.81"
					y1="54.05"
					x2="572.81"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.81"
					y1="53.55"
					x2="577.27"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.27"
					y1="53.55"
					x2="577.27"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="510.83 53.55 515.29 53.55 515.29 54.05 512.81 54.05 512.81 59 510.83 59 510.83 53.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.83"
					y1="53.55"
					x2="515.29"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.29"
					y1="53.55"
					x2="515.29"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.29"
					y1="54.05"
					x2="512.81"
					y2="54.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.81"
					y1="54.05"
					x2="512.81"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.81"
					y1="59"
					x2="510.83"
					y2="59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.83"
					y1="59"
					x2="510.83"
					y2="53.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="577.27 55.04 582.3 55.04 582.3 70.14 577.27 70.14 577.27 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="582.3"
					y1="55.04"
					x2="577.27"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.3"
					y1="70.14"
					x2="582.3"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.27"
					y1="70.14"
					x2="582.3"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.27"
					y1="55.04"
					x2="577.27"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="505.8 55.04 510.83 55.04 510.83 70.14 505.8 70.14 505.8 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.83"
					y1="55.04"
					x2="505.8"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.83"
					y1="70.14"
					x2="510.83"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.8"
					y1="70.14"
					x2="510.83"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.8"
					y1="55.04"
					x2="505.8"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="582.3 55.04 582.3 70.14 577.27 70.14 577.27 55.04 582.3 55.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="582.3"
					y1="70.14"
					x2="582.3"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.27"
					y1="70.14"
					x2="582.3"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.27"
					y1="55.04"
					x2="577.27"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.3"
					y1="55.04"
					x2="577.27"
					y2="55.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.3"
					y1="50"
					x2="582.3"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="948.74"
					x2="580.52"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="580.52"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="576.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="948.74"
					x2="477.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="477.35"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="481.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="928.61"
					x2="576.75"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="482.38 950 482.38 948.74 477.35 948.74 477.35 950 482.38 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.49 948.74 575.49 950 580.52 950 580.52 948.74 575.49 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="482.38 928.61 482.38 927.35 477.35 927.35 477.35 928.61 482.38 928.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.49 927.35 575.49 928.61 580.52 928.61 580.52 927.35 575.49 927.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="482.38"
					y1="950"
					x2="477.35"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.35"
					y1="950"
					x2="477.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.35"
					y1="948.74"
					x2="482.38"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.38"
					y1="948.74"
					x2="482.38"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.49"
					y1="948.74"
					x2="580.52"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.52"
					y1="948.74"
					x2="580.52"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.52"
					y1="950"
					x2="575.49"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.49"
					y1="950"
					x2="575.49"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.38"
					y1="928.61"
					x2="477.35"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.35"
					y1="928.61"
					x2="477.35"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.35"
					y1="927.35"
					x2="482.38"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.38"
					y1="927.35"
					x2="482.38"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.49"
					y1="927.35"
					x2="580.52"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.52"
					y1="927.35"
					x2="580.52"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.52"
					y1="928.61"
					x2="575.49"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.49"
					y1="928.61"
					x2="575.49"
					y2="927.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="483.65 948.74 483.65 928.61 481.76 928.61 481.76 948.74 483.65 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="576.12 948.74 576.12 928.61 574.24 928.61 574.24 948.74 576.12 948.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="510.18 864.55 507.06 867.67 571.12 931.73 574.24 928.61 510.18 864.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="481.76"
					y1="928.61"
					x2="481.13"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.76"
					y1="948.74"
					x2="481.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="481.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="928.61"
					x2="576.75"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="948.74"
					x2="576.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="576.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.65"
					y1="948.74"
					x2="483.65"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.65"
					y1="928.61"
					x2="481.76"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.76"
					y1="928.61"
					x2="481.76"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.76"
					y1="948.74"
					x2="483.65"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="948.74"
					x2="576.12"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.12"
					y1="928.61"
					x2="574.24"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.24"
					y1="928.61"
					x2="574.24"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.24"
					y1="948.74"
					x2="576.12"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.18"
					y1="864.55"
					x2="507.06"
					y2="867.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.06"
					y1="867.67"
					x2="571.12"
					y2="931.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.12"
					y1="931.73"
					x2="574.24"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.24"
					y1="928.61"
					x2="510.18"
					y2="864.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="481.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="481.13"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="477.35"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="928.61"
					x2="477.35"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="948.74"
					x2="477.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="481.13"
					y1="948.74"
					x2="477.35"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="576.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="576.75"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="580.52"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="928.61"
					x2="580.52"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="948.74"
					x2="580.52"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="576.75"
					y1="948.74"
					x2="580.52"
					y2="948.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="333.79"
					y1="928.61"
					x2="333.79"
					y2="908.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="224.23"
					y1="908.15"
					x2="224.23"
					y2="606.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="914.19"
					x2="580.35"
					y2="917.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="914.19"
					x2="580.35"
					y2="914.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="833.66"
					x2="580.35"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="592.93"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="580.35"
					y2="833.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="592.93"
					y2="695.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="914.19"
					x2="580.35"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="579.09 834.92 580.35 834.92 580.35 829.89 579.09 829.89 579.09 834.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="580.35 912.93 579.09 912.93 579.09 917.96 580.35 917.96 580.35 912.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="592.93 834.92 594.19 834.92 594.19 829.89 592.93 829.89 592.93 834.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="579.09"
					y1="834.92"
					x2="579.09"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.09"
					y1="829.89"
					x2="580.35"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="829.89"
					x2="580.35"
					y2="834.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="834.92"
					x2="579.09"
					y2="834.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="912.93"
					x2="580.35"
					y2="917.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="917.96"
					x2="579.09"
					y2="917.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.09"
					y1="917.96"
					x2="579.09"
					y2="912.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.09"
					y1="912.93"
					x2="580.35"
					y2="912.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="834.92"
					x2="592.93"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="829.89"
					x2="594.19"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.19"
					y1="829.89"
					x2="594.19"
					y2="834.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.19"
					y1="834.92"
					x2="592.93"
					y2="834.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="912.93"
					x2="594.19"
					y2="912.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="580.35 836.18 592.93 836.18 592.93 834.29 580.35 834.29 580.35 836.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="580.35 913.55 592.93 913.55 592.93 911.67 580.35 911.67 580.35 913.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="646.31 858.29 643.2 855.18 589.82 908.55 592.93 911.67 646.31 858.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="592.93"
					y1="834.29"
					x2="592.93"
					y2="833.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="834.29"
					x2="580.35"
					y2="833.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="580.35"
					y2="833.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="913.55"
					x2="592.93"
					y2="914.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="913.55"
					x2="580.35"
					y2="914.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="914.19"
					x2="580.35"
					y2="914.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="836.18"
					x2="592.93"
					y2="836.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="836.18"
					x2="592.93"
					y2="834.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="834.29"
					x2="580.35"
					y2="834.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="834.29"
					x2="580.35"
					y2="836.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="913.55"
					x2="592.93"
					y2="913.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="913.55"
					x2="592.93"
					y2="911.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="911.67"
					x2="580.35"
					y2="911.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.35"
					y1="911.67"
					x2="580.35"
					y2="913.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.31"
					y1="858.29"
					x2="643.2"
					y2="855.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.2"
					y1="855.18"
					x2="589.82"
					y2="908.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.82"
					y1="908.55"
					x2="592.93"
					y2="911.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="911.67"
					x2="646.31"
					y2="858.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="580.35"
					y2="833.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="580.35"
					y2="833.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="592.93"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="833.66"
					x2="592.93"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="833.66"
					x2="580.35"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="833.66"
					x2="580.35"
					y2="829.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="914.19"
					x2="580.35"
					y2="914.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="914.19"
					x2="580.35"
					y2="914.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="914.19"
					x2="580.35"
					y2="917.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="580.35"
					y1="914.19"
					x2="580.35"
					y2="917.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="625.4"
					x2="685.2"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="685.2"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="681.43"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="597.13"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="600.91"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="625.4"
					x2="791.04"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="612.82"
					x2="681.43"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="680.17 625.4 680.17 626.66 685.2 626.66 685.2 625.4 680.17 625.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="602.16 612.82 602.16 611.56 597.13 611.56 597.13 612.82 602.16 612.82"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="680.17 611.56 680.17 612.82 685.2 612.82 685.2 611.56 680.17 611.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="602.16"
					y1="625.4"
					x2="602.16"
					y2="626.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.17"
					y1="625.4"
					x2="685.2"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.2"
					y1="625.4"
					x2="685.2"
					y2="626.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.2"
					y1="626.66"
					x2="680.17"
					y2="626.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.17"
					y1="626.66"
					x2="680.17"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.16"
					y1="612.82"
					x2="597.13"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.13"
					y1="612.82"
					x2="597.13"
					y2="611.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.13"
					y1="611.56"
					x2="602.16"
					y2="611.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.16"
					y1="611.56"
					x2="602.16"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.17"
					y1="611.56"
					x2="685.2"
					y2="611.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.2"
					y1="611.56"
					x2="685.2"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="685.2"
					y1="612.82"
					x2="680.17"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.17"
					y1="612.82"
					x2="680.17"
					y2="611.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="603.42 625.4 603.42 612.82 601.54 612.82 601.54 625.4 603.42 625.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="680.8 625.4 680.8 612.82 678.91 612.82 678.91 625.4 680.8 625.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="625.53 559.44 622.42 562.55 675.8 615.93 678.91 612.82 625.53 559.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="601.54"
					y1="612.82"
					x2="600.91"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.54"
					y1="625.4"
					x2="600.91"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="600.91"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="612.82"
					x2="681.43"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="625.4"
					x2="681.43"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="681.43"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.42"
					y1="625.4"
					x2="603.42"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.42"
					y1="612.82"
					x2="601.54"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.54"
					y1="612.82"
					x2="601.54"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.54"
					y1="625.4"
					x2="603.42"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="625.4"
					x2="680.8"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.8"
					y1="612.82"
					x2="678.91"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.91"
					y1="612.82"
					x2="678.91"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.91"
					y1="625.4"
					x2="680.8"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.53"
					y1="559.44"
					x2="622.42"
					y2="562.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.42"
					y1="562.55"
					x2="675.8"
					y2="615.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.8"
					y1="615.93"
					x2="678.91"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.91"
					y1="612.82"
					x2="625.53"
					y2="559.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="600.91"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="600.91"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="597.13"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="600.91"
					y1="612.82"
					x2="597.13"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="681.43"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="681.43"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="685.2"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="612.82"
					x2="685.2"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="625.4"
					x2="685.2"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="681.43"
					y1="625.4"
					x2="685.2"
					y2="625.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="753.7"
					y1="774.5"
					x2="761.99"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="753.7"
					y1="695.54"
					x2="753.7"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="592.93"
					y1="695.54"
					x2="753.7"
					y2="695.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="761.99"
					y1="774.5"
					x2="761.99"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="598.52"
					x2="707.54"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="694.96"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="707.54"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="517.99"
					x2="707.54"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="694.96"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="707.54"
					y2="517.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="612.82"
					x2="707.54"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="694.96"
					y2="612.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="708.8 519.25 708.8 514.22 707.54 514.22 707.54 519.25 708.8 519.25"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="707.54 597.26 707.54 602.29 708.8 602.29 708.8 597.26 707.54 597.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="694.96 519.25 694.96 514.22 693.7 514.22 693.7 519.25 694.96 519.25"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="693.7 597.26 693.7 602.29 694.96 602.29 694.96 597.26 693.7 597.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.8"
					y1="519.25"
					x2="708.8"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.8"
					y1="514.22"
					x2="707.54"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="514.22"
					x2="707.54"
					y2="519.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="519.25"
					x2="708.8"
					y2="519.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="597.26"
					x2="707.54"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="602.29"
					x2="708.8"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.8"
					y1="602.29"
					x2="708.8"
					y2="597.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.8"
					y1="597.26"
					x2="707.54"
					y2="597.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="519.25"
					x2="694.96"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="514.22"
					x2="693.7"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.7"
					y1="514.22"
					x2="693.7"
					y2="519.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.7"
					y1="519.25"
					x2="694.96"
					y2="519.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.7"
					y1="597.26"
					x2="693.7"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.7"
					y1="602.29"
					x2="694.96"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="602.29"
					x2="694.96"
					y2="597.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="597.26"
					x2="693.7"
					y2="597.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="707.54 520.51 707.54 518.62 694.96 518.62 694.96 520.51 707.54 520.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="707.54 597.89 707.54 596 694.96 596 694.96 597.89 707.54 597.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="641.58 542.62 694.96 596 698.08 592.89 644.69 539.5 641.58 542.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.96"
					y1="518.62"
					x2="694.96"
					y2="517.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="518.62"
					x2="707.54"
					y2="517.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="707.54"
					y2="517.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="597.89"
					x2="694.96"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="597.89"
					x2="707.54"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="707.54"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="520.51"
					x2="694.96"
					y2="520.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="520.51"
					x2="694.96"
					y2="518.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="518.62"
					x2="707.54"
					y2="518.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="518.62"
					x2="707.54"
					y2="520.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="597.89"
					x2="694.96"
					y2="597.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="597.89"
					x2="694.96"
					y2="596"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="596"
					x2="707.54"
					y2="596"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.54"
					y1="596"
					x2="707.54"
					y2="597.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.58"
					y1="542.62"
					x2="644.69"
					y2="539.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.69"
					y1="539.5"
					x2="698.08"
					y2="592.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.08"
					y1="592.89"
					x2="694.96"
					y2="596"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="596"
					x2="641.58"
					y2="542.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="707.54"
					y2="517.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="707.54"
					y2="517.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="694.96"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="517.99"
					x2="694.96"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="517.99"
					x2="707.54"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="517.99"
					x2="707.54"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="707.54"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="707.54"
					y2="598.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="694.96"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="694.96"
					y1="598.52"
					x2="694.96"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="598.52"
					x2="707.54"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="707.54"
					y1="598.52"
					x2="707.54"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="487.09"
					x2="513.31"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="513.31"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="517.08"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="487.09"
					x2="601.38"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="601.38"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="597.61"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="596.35 488.35 601.38 488.35 601.38 487.09 596.35 487.09 596.35 488.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="518.34 487.09 513.31 487.09 513.31 488.35 518.34 488.35 518.34 487.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.35 474.51 601.38 474.51 601.38 473.25 596.35 473.25 596.35 474.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="518.34 473.25 513.31 473.25 513.31 474.51 518.34 474.51 518.34 473.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="596.35"
					y1="488.35"
					x2="601.38"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.38"
					y1="488.35"
					x2="601.38"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.38"
					y1="487.09"
					x2="596.35"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.35"
					y1="487.09"
					x2="596.35"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.34"
					y1="487.09"
					x2="513.31"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.31"
					y1="487.09"
					x2="513.31"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.31"
					y1="488.35"
					x2="518.34"
					y2="488.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.34"
					y1="488.35"
					x2="518.34"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.35"
					y1="474.51"
					x2="601.38"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.38"
					y1="474.51"
					x2="601.38"
					y2="473.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.38"
					y1="473.25"
					x2="596.35"
					y2="473.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.35"
					y1="473.25"
					x2="596.35"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.34"
					y1="473.25"
					x2="513.31"
					y2="473.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.31"
					y1="473.25"
					x2="513.31"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="513.31"
					y1="474.51"
					x2="518.34"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="518.34"
					y1="474.51"
					x2="518.34"
					y2="473.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="595.09 487.09 596.98 487.09 596.98 474.51 595.09 474.51 595.09 487.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="517.71 487.09 519.6 487.09 519.6 474.51 517.71 474.51 517.71 487.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="572.98 421.13 519.6 474.51 522.71 477.62 576.1 424.24 572.98 421.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="596.98"
					y1="474.51"
					x2="597.61"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.98"
					y1="487.09"
					x2="597.61"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="597.61"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.71"
					y1="474.51"
					x2="517.08"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.71"
					y1="487.09"
					x2="517.08"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="517.08"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.09"
					y1="487.09"
					x2="595.09"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.09"
					y1="474.51"
					x2="596.98"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.98"
					y1="474.51"
					x2="596.98"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.98"
					y1="487.09"
					x2="595.09"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.71"
					y1="487.09"
					x2="517.71"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.71"
					y1="474.51"
					x2="519.6"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.6"
					y1="474.51"
					x2="519.6"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.6"
					y1="487.09"
					x2="517.71"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572.98"
					y1="421.13"
					x2="576.1"
					y2="424.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.1"
					y1="424.24"
					x2="522.71"
					y2="477.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.71"
					y1="477.62"
					x2="519.6"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.6"
					y1="474.51"
					x2="572.98"
					y2="421.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="597.61"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="597.61"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="601.38"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="474.51"
					x2="601.38"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="487.09"
					x2="601.38"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="597.61"
					y1="487.09"
					x2="601.38"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="517.08"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="517.08"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="513.31"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="474.51"
					x2="513.31"
					y2="474.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="487.09"
					x2="513.31"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="517.08"
					y1="487.09"
					x2="513.31"
					y2="487.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="416.24"
					x2="759.96"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="759.96"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="756.18"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="416.24"
					x2="671.89"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="671.89"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="675.66"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="676.92 417.49 676.92 416.24 671.89 416.24 671.89 417.49 676.92 417.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="754.93 416.24 754.93 417.49 759.96 417.49 759.96 416.24 754.93 416.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="676.92 403.65 676.92 402.4 671.89 402.4 671.89 403.65 676.92 403.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="754.93 402.4 754.93 403.65 759.96 403.65 759.96 402.4 754.93 402.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="676.92"
					y1="417.49"
					x2="671.89"
					y2="417.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.89"
					y1="417.49"
					x2="671.89"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.89"
					y1="416.24"
					x2="676.92"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.92"
					y1="416.24"
					x2="676.92"
					y2="417.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.93"
					y1="416.24"
					x2="759.96"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.96"
					y1="416.24"
					x2="759.96"
					y2="417.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.96"
					y1="417.49"
					x2="754.93"
					y2="417.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.93"
					y1="417.49"
					x2="754.93"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.92"
					y1="403.65"
					x2="671.89"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.89"
					y1="403.65"
					x2="671.89"
					y2="402.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.89"
					y1="402.4"
					x2="676.92"
					y2="402.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.92"
					y1="402.4"
					x2="676.92"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.93"
					y1="402.4"
					x2="759.96"
					y2="402.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.96"
					y1="402.4"
					x2="759.96"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.96"
					y1="403.65"
					x2="754.93"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.93"
					y1="403.65"
					x2="754.93"
					y2="402.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="678.18 416.24 678.18 403.65 676.29 403.65 676.29 416.24 678.18 416.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="755.55 416.24 755.55 403.65 753.67 403.65 753.67 416.24 755.55 416.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="700.29 350.27 697.17 353.39 750.55 406.77 753.67 403.65 700.29 350.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="676.29"
					y1="403.65"
					x2="675.66"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.29"
					y1="416.24"
					x2="675.66"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="675.66"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.55"
					y1="403.65"
					x2="756.18"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.55"
					y1="416.24"
					x2="756.18"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="756.18"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.18"
					y1="416.24"
					x2="678.18"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.18"
					y1="403.65"
					x2="676.29"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.29"
					y1="403.65"
					x2="676.29"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.29"
					y1="416.24"
					x2="678.18"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.55"
					y1="416.24"
					x2="755.55"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.55"
					y1="403.65"
					x2="753.67"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.67"
					y1="403.65"
					x2="753.67"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.67"
					y1="416.24"
					x2="755.55"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.29"
					y1="350.27"
					x2="697.17"
					y2="353.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.17"
					y1="353.39"
					x2="750.55"
					y2="406.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.55"
					y1="406.77"
					x2="753.67"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.67"
					y1="403.65"
					x2="700.29"
					y2="350.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="675.66"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="675.66"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="671.89"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="403.65"
					x2="671.89"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="416.24"
					x2="671.89"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="675.66"
					y1="416.24"
					x2="671.89"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="756.18"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="756.18"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="759.96"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="403.65"
					x2="759.96"
					y2="403.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="416.24"
					x2="759.96"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="756.18"
					y1="416.24"
					x2="759.96"
					y2="416.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="404.06"
					y1="50"
					x2="404.06"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="505.44"
					y1="70.14"
					x2="505.44"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="235.58"
					y1="70.14"
					x2="235.58"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="753.7 774.5 753.7 695.54 592.93 695.54 592.93 774.5 753.7 774.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="592.93"
					y1="774.5"
					x2="753.7"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.93"
					y1="695.54"
					x2="592.93"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.7"
					y1="695.54"
					x2="592.93"
					y2="695.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.7"
					y1="774.5"
					x2="753.7"
					y2="695.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.89"
					y1="769.55"
					x2="748.75"
					y2="769.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.75"
					y1="769.55"
					x2="748.75"
					y2="700.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.75"
					y1="700.5"
					x2="597.89"
					y2="700.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.89"
					y1="700.5"
					x2="597.89"
					y2="769.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.89"
					y1="769.55"
					x2="666.01"
					y2="738.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.89"
					y1="700.5"
					x2="666.01"
					y2="731.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.75"
					y1="769.55"
					x2="680.62"
					y2="738.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.75"
					y1="700.5"
					x2="680.62"
					y2="731.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.32"
					y1="739.98"
					x2="673.32"
					y2="730.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.27"
					y1="735.02"
					x2="668.36"
					y2="735.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m681.24,735.02c0-4.38-3.55-7.92-7.92-7.92s-7.92,3.55-7.92,7.92,3.55,7.92,7.92,7.92,7.92-3.55,7.92-7.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m678.27,735.02c0-2.73-2.22-4.95-4.95-4.95s-4.95,2.22-4.95,4.95,2.22,4.95,4.95,4.95,4.95-2.22,4.95-4.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="753.7 735.02 743.19 742.76 743.19 727.29 753.7 735.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="753.7"
					y1="735.02"
					x2="743.19"
					y2="742.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="742.76"
					x2="743.19"
					y2="727.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="727.29"
					x2="753.7"
					y2="735.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.79"
					y1="735.02"
					x2="734.34"
					y2="735.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="735.02"
					x2="743.19"
					y2="727.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="727.29"
					x2="753.7"
					y2="735.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="735.02"
					x2="743.19"
					y2="742.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.19"
					y1="742.76"
					x2="753.7"
					y2="735.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.99"
					y1="732.74"
					x2="735.39"
					y2="729.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.99"
					y1="737.3"
					x2="735.39"
					y2="740.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="711.69 838.86 761.99 838.86 761.99 774.5 711.69 774.5 711.69 838.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="711.69"
					y1="838.86"
					x2="711.69"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.99"
					y1="838.86"
					x2="761.99"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.69"
					y1="774.5"
					x2="761.99"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.69"
					y1="838.86"
					x2="761.99"
					y2="838.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.01"
					y1="838.86"
					x2="760.01"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.63"
					y1="831.85"
					x2="723.63"
					y2="781.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.63"
					y1="781.51"
					x2="753.82"
					y2="781.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.82"
					y1="781.51"
					x2="753.82"
					y2="831.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.82"
					y1="831.85"
					x2="723.63"
					y2="831.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.65"
					y1="833.83"
					x2="721.65"
					y2="779.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.65"
					y1="779.53"
					x2="755.81"
					y2="779.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.81"
					y1="779.53"
					x2="755.81"
					y2="833.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.81"
					y1="833.83"
					x2="721.65"
					y2="833.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m749.98,806.68c0-1.64-1.33-2.97-2.97-2.97s-2.97,1.33-2.97,2.97,1.33,2.97,2.97,2.97,2.97-1.33,2.97-2.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="759.27 809.16 755.12 808.76 754.18 808.44 748.93 807.78 748.24 807.41 747.96 806.68 748.24 805.95 748.93 805.58 754.18 804.92 755.12 804.6 759.27 804.2 760.73 804.68 761.63 805.92 761.63 807.44 760.73 808.69 759.27 809.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.27"
					y1="809.16"
					x2="755.12"
					y2="808.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m755.12,808.76c-.34-.03-.66-.14-.94-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.18"
					y1="808.44"
					x2="748.93"
					y2="807.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m748.93,807.78c-.55-.07-.97-.54-.97-1.1s.42-1.03.97-1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.93"
					y1="805.58"
					x2="754.18"
					y2="804.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m754.18,804.92c.28-.18.61-.29.94-.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.12"
					y1="804.6"
					x2="759.27"
					y2="804.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m759.27,804.2c1.37,0,2.48,1.11,2.48,2.48s-1.11,2.48-2.48,2.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.81"
					y1="805.33"
					x2="755.33"
					y2="805.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.33"
					y1="808.03"
					x2="756.81"
					y2="808.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.81"
					y1="808.03"
					x2="756.81"
					y2="805.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m755.33,808.03c-.74,0-1.35-.6-1.35-1.35s.6-1.35,1.35-1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m754.18,808.44c-.6-.39-.96-1.05-.96-1.76s.36-1.37.96-1.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="695.91 872.03 693.91 876.52 693.21 881.39 693.91 886.26 695.91 890.75 698.45 893.7 701.64 895.95 709.13 898.8 715.35 899.8 721.64 899.43 727.69 897.69 733.23 897.83 738.59 899.23 743.49 901.82 745.61 903.17 749.99 904.77 754.64 904.53 756.47 903.81 761.36 903.81 761.36 901.77 759.13 901.77 761.19 898.36 761.99 894.46 761.99 868.31 760.63 863.26 757.03 859.47 752.06 857.84 751.46 857.84 748.32 858.36 743.37 861.02 738.53 863.58 733.23 864.97 727.76 865.11 721.68 863.35 715.37 862.97 709.13 863.97 701.64 866.82 698.45 869.07 695.91 872.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="738.76"
					y1="890.7"
					x2="738.76"
					y2="872.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.99"
					y1="868.31"
					x2="761.99"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="868.31"
					x2="761.05"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.99"
					y1="894.46"
					x2="761.99"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="894.46"
					x2="761.05"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.76"
					y1="872.56"
					x2="742.24"
					y2="872.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.24"
					y1="872.56"
					x2="742.24"
					y2="875.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.24"
					y1="875.43"
					x2="738.76"
					y2="875.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.76"
					y1="890.22"
					x2="742.24"
					y2="890.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.24"
					y1="890.22"
					x2="742.24"
					y2="887.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.24"
					y1="887.34"
					x2="738.76"
					y2="887.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.71"
					y1="901.77"
					x2="761.36"
					y2="901.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.71"
					y1="903.81"
					x2="761.36"
					y2="903.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.36"
					y1="903.81"
					x2="761.36"
					y2="901.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.71"
					y1="903.81"
					x2="752.71"
					y2="901.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.21"
					y1="881.39"
					x2="693.57"
					y2="878.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.57"
					y1="878.27"
					x2="694.37"
					y2="875.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.37"
					y1="875.24"
					x2="695.91"
					y2="872.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.91"
					y1="872.03"
					x2="698.45"
					y2="869.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.45"
					y1="869.06"
					x2="701.64"
					y2="866.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.64"
					y1="866.82"
					x2="705.28"
					y2="865.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.28"
					y1="865.17"
					x2="709.13"
					y2="863.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.13"
					y1="863.97"
					x2="715.36"
					y2="862.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.36"
					y1="862.89"
					x2="718.5"
					y2="862.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.5"
					y1="862.83"
					x2="721.64"
					y2="863.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.64"
					y1="863.18"
					x2="726.5"
					y2="864.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.5"
					y1="864.6"
					x2="731.2"
					y2="866.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.2"
					y1="866.8"
					x2="735.4"
					y2="869.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.4"
					y1="869.42"
					x2="738.76"
					y2="872.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.76"
					y1="865.11"
					x2="732.12"
					y2="865.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.12"
					y1="865.08"
					x2="736.36"
					y2="864.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.36"
					y1="864.36"
					x2="740.91"
					y2="862.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.91"
					y1="862.56"
					x2="744.21"
					y2="860.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.21"
					y1="860.46"
					x2="747.62"
					y2="858.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.62"
					y1="858.61"
					x2="750.95"
					y2="857.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.95"
					y1="857.86"
					x2="754.27"
					y2="858.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.27"
					y1="858.15"
					x2="757.29"
					y2="859.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.29"
					y1="859.44"
					x2="759.72"
					y2="861.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.72"
					y1="861.72"
					x2="760.95"
					y2="863.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.95"
					y1="863.96"
					x2="761.64"
					y2="866.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.64"
					y1="866.09"
					x2="761.99"
					y2="868.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="868.31"
					x2="760.96"
					y2="867.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.96"
					y1="867.32"
					x2="760.32"
					y2="865.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.32"
					y1="865.27"
					x2="758.79"
					y2="863.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.79"
					y1="863.45"
					x2="756.66"
					y2="862.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.66"
					y1="862.31"
					x2="753.85"
					y2="861.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.85"
					y1="861.77"
					x2="750.96"
					y2="861.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.96"
					y1="861.64"
					x2="749.52"
					y2="861.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.52"
					y1="861.66"
					x2="748.38"
					y2="862.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="862.27"
					x2="748.05"
					y2="862.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.05"
					y1="862.98"
					x2="745.8"
					y2="870.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.8"
					y1="870.88"
					x2="745.13"
					y2="874.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.13"
					y1="874.81"
					x2="744.85"
					y2="878.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.85"
					y1="878.79"
					x2="744.85"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.69"
					y1="897.69"
					x2="732.07"
					y2="897.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.07"
					y1="897.72"
					x2="736.33"
					y2="898.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.33"
					y1="898.44"
					x2="740.91"
					y2="900.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.91"
					y1="900.21"
					x2="744.22"
					y2="902.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.22"
					y1="902.3"
					x2="747.62"
					y2="904.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.62"
					y1="904.16"
					x2="749.84"
					y2="904.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.84"
					y1="904.78"
					x2="752.13"
					y2="904.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.13"
					y1="904.92"
					x2="754.37"
					y2="904.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.37"
					y1="904.6"
					x2="756.47"
					y2="903.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.05"
					y1="894.46"
					x2="760.96"
					y2="895.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.96"
					y1="895.45"
					x2="760.32"
					y2="897.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.32"
					y1="897.51"
					x2="758.79"
					y2="899.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.79"
					y1="899.33"
					x2="756.66"
					y2="900.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.66"
					y1="900.46"
					x2="753.85"
					y2="901"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.85"
					y1="901"
					x2="750.96"
					y2="901.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.96"
					y1="901.13"
					x2="749.52"
					y2="901.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.52"
					y1="901.11"
					x2="748.38"
					y2="900.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="900.5"
					x2="748.05"
					y2="899.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.05"
					y1="899.8"
					x2="745.8"
					y2="891.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.8"
					y1="891.89"
					x2="745.13"
					y2="887.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.13"
					y1="887.96"
					x2="744.85"
					y2="883.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.85"
					y1="883.98"
					x2="744.85"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.21"
					y1="881.39"
					x2="693.57"
					y2="884.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.57"
					y1="884.51"
					x2="694.37"
					y2="887.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.37"
					y1="887.53"
					x2="695.91"
					y2="890.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.91"
					y1="890.75"
					x2="698.45"
					y2="893.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.45"
					y1="893.71"
					x2="701.64"
					y2="895.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.64"
					y1="895.95"
					x2="705.28"
					y2="897.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.28"
					y1="897.6"
					x2="709.13"
					y2="898.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.13"
					y1="898.8"
					x2="715.36"
					y2="899.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.36"
					y1="899.89"
					x2="718.5"
					y2="899.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.5"
					y1="899.94"
					x2="721.64"
					y2="899.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.64"
					y1="899.59"
					x2="726.5"
					y2="898.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.5"
					y1="898.18"
					x2="731.2"
					y2="895.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.2"
					y1="895.97"
					x2="735.4"
					y2="893.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.4"
					y1="893.36"
					x2="738.76"
					y2="890.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.81"
					y1="859.48"
					x2="745.1"
					y2="859.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.1"
					y1="859.98"
					x2="744.04"
					y2="861.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.04"
					y1="861.42"
					x2="743.79"
					y2="862.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.79"
					y1="862.67"
					x2="743.1"
					y2="870.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.1"
					y1="870.7"
					x2="742.79"
					y2="878.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.79"
					y1="878.75"
					x2="742.79"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.81"
					y1="903.29"
					x2="745.1"
					y2="902.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.1"
					y1="902.79"
					x2="744.04"
					y2="901.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.04"
					y1="901.35"
					x2="743.79"
					y2="900.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.79"
					y1="900.1"
					x2="743.1"
					y2="892.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.1"
					y1="892.07"
					x2="742.79"
					y2="884.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.79"
					y1="884.02"
					x2="742.79"
					y2="881.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.13"
					y1="901.77"
					x2="759.72"
					y2="901.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.72"
					y1="901.05"
					x2="760.95"
					y2="898.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.95"
					y1="898.82"
					x2="761.64"
					y2="896.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.64"
					y1="896.69"
					x2="761.99"
					y2="894.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="761.99 851.19 760.99 851.19 760.99 856.22 761.99 856.22 761.99 851.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="761.99"
					y1="856.22"
					x2="761.99"
					y2="851.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="856.22"
					x2="761.99"
					y2="856.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="851.19"
					x2="760.99"
					y2="856.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.99"
					y1="851.19"
					x2="760.99"
					y2="851.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="761.99 911.58 761.99 906.55 760.99 906.55 760.99 911.58 761.99 911.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="760.99"
					y1="911.58"
					x2="761.99"
					y2="911.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="906.55"
					x2="760.99"
					y2="911.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.99"
					y1="906.55"
					x2="760.99"
					y2="906.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.99"
					y1="911.58"
					x2="761.99"
					y2="906.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="760.99 853.2 752.8 853.2 752.8 854.21 760.99 854.21 760.99 853.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="760.99"
					y1="854.21"
					x2="760.99"
					y2="853.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.8"
					y1="854.21"
					x2="760.99"
					y2="854.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.8"
					y1="853.2"
					x2="752.8"
					y2="854.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="853.2"
					x2="752.8"
					y2="853.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="760.99 909.57 760.99 908.56 752.8 908.56 752.8 909.57 760.99 909.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.8"
					y1="909.57"
					x2="760.99"
					y2="909.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.8"
					y1="908.56"
					x2="752.8"
					y2="909.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="908.56"
					x2="752.8"
					y2="908.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.99"
					y1="909.57"
					x2="760.99"
					y2="908.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.31 854.21 753.3 854.21 753.3 908.56 755.31 908.56 755.31 854.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.31"
					y1="908.56"
					x2="755.31"
					y2="854.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.3"
					y1="908.56"
					x2="755.31"
					y2="908.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.3"
					y1="854.21"
					x2="753.3"
					y2="908.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.31"
					y1="854.21"
					x2="753.3"
					y2="854.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="928.61"
					x2="418.76"
					y2="835.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.79"
					y1="835.45"
					x2="333.79"
					y2="928.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="835.45"
					x2="333.79"
					y2="835.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="841.74"
					x2="333.79"
					y2="841.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="284.63 666.9 227.21 666.9 227.21 610.47 284.63 610.47 284.63 666.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="284.63"
					y1="666.9"
					x2="281.89"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.26"
					y1="666.9"
					x2="272.22"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.6"
					y1="666.9"
					x2="262.56"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.94"
					y1="666.9"
					x2="252.9"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.27"
					y1="666.9"
					x2="243.23"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.61"
					y1="666.9"
					x2="233.57"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.95"
					y1="666.9"
					x2="227.21"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="666.9"
					x2="227.21"
					y2="664.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="661.03"
					x2="227.21"
					y2="654.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="651.37"
					x2="227.21"
					y2="645.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="641.7"
					x2="227.21"
					y2="635.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="632.04"
					x2="227.21"
					y2="626"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="622.38"
					x2="227.21"
					y2="616.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="612.72"
					x2="227.21"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="610.47"
					x2="229.95"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.57"
					y1="610.47"
					x2="239.61"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.23"
					y1="610.47"
					x2="249.27"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.9"
					y1="610.47"
					x2="258.94"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.56"
					y1="610.47"
					x2="268.6"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.22"
					y1="610.47"
					x2="278.26"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.89"
					y1="610.47"
					x2="284.63"
					y2="610.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="610.47"
					x2="284.63"
					y2="612.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="616.34"
					x2="284.63"
					y2="622.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="626"
					x2="284.63"
					y2="632.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="635.67"
					x2="284.63"
					y2="641.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="645.33"
					x2="284.63"
					y2="651.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="654.99"
					x2="284.63"
					y2="661.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="664.66"
					x2="284.63"
					y2="666.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="287.6 610.69 289.33 610.69 289.33 666.69 287.6 666.69 287.6 657.9 289.02 657.9 289.02 619.47 287.6 619.47 287.6 610.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.6"
					y1="610.69"
					x2="289.33"
					y2="610.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="289.33"
					y1="610.69"
					x2="289.33"
					y2="666.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="289.33"
					y1="666.69"
					x2="287.6"
					y2="666.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="287.6"
					y1="666.69"
					x2="287.6"
					y2="657.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="287.6"
					y1="657.9"
					x2="289.02"
					y2="657.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="289.02"
					y1="657.9"
					x2="289.02"
					y2="619.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="289.02"
					y1="619.47"
					x2="287.6"
					y2="619.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="287.6"
					y1="619.47"
					x2="287.6"
					y2="610.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<polyline
					points="287.6 608.49 287.6 668.88 284.63 668.88 284.63 608.49 287.6 608.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="287.6"
					y1="608.49"
					x2="287.6"
					y2="668.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="287.6"
					y1="668.88"
					x2="284.63"
					y2="668.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="284.63"
					y1="668.88"
					x2="284.63"
					y2="608.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="284.63"
					y1="608.49"
					x2="287.6"
					y2="608.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="287.6"
					y1="666.69"
					x2="289.33"
					y2="666.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.33"
					y1="666.69"
					x2="289.33"
					y2="610.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.33"
					y1="610.69"
					x2="287.6"
					y2="610.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.6"
					y1="668.88"
					x2="287.6"
					y2="608.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.6"
					y1="619.47"
					x2="289.02"
					y2="619.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.02"
					y1="619.47"
					x2="289.02"
					y2="657.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.02"
					y1="657.9"
					x2="287.6"
					y2="657.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="668.88"
					x2="287.6"
					y2="668.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.6"
					y1="608.49"
					x2="284.63"
					y2="608.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="608.49"
					x2="284.63"
					y2="668.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="289.66 746.23 224.23 746.23 224.23 821.72 289.66 821.72 289.66 746.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="289.66"
					y1="746.23"
					x2="289.66"
					y2="821.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.23"
					y1="746.23"
					x2="224.23"
					y2="821.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.22"
					y1="746.23"
					x2="226.22"
					y2="821.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.66"
					y1="746.23"
					x2="224.23"
					y2="746.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.66"
					y1="821.72"
					x2="224.23"
					y2="821.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.69"
					y1="751.18"
					x2="286.69"
					y2="816.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.69"
					y1="816.76"
					x2="284.71"
					y2="818.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.71"
					y1="818.75"
					x2="229.19"
					y2="818.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.19"
					y1="818.75"
					x2="227.21"
					y2="816.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="816.76"
					x2="227.21"
					y2="751.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="751.18"
					x2="229.19"
					y2="749.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.19"
					y1="749.2"
					x2="284.71"
					y2="749.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.71"
					y1="749.2"
					x2="286.69"
					y2="751.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m283.21,765.1c0-5.47-4.43-9.91-9.91-9.91s-9.91,4.44-9.91,9.91,4.43,9.91,9.91,9.91,9.91-4.44,9.91-9.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m248.02,765.1c0-4.1-3.33-7.43-7.43-7.43s-7.43,3.33-7.43,7.43,3.33,7.43,7.43,7.43,7.43-3.33,7.43-7.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m280.73,802.85c0-4.1-3.33-7.43-7.43-7.43s-7.43,3.33-7.43,7.43,3.33,7.43,7.43,7.43,7.43-3.33,7.43-7.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m250.5,802.85c0-5.47-4.44-9.91-9.91-9.91s-9.91,4.44-9.91,9.91,4.44,9.91,9.91,9.91,9.91-4.44,9.91-9.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.4 677.11 277.4 739.79 276.81 741.19 275.41 741.77 233.45 741.77 232.05 741.19 231.47 739.79 231.47 677.11 232.05 675.71 233.45 675.13 275.41 675.13 276.81 675.71 277.4 677.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.4"
					y1="677.11"
					x2="277.4"
					y2="739.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m277.4,739.79c0,1.09-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.41"
					y1="741.77"
					x2="233.45"
					y2="741.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m233.45,741.77c-1.09,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.47"
					y1="739.79"
					x2="231.47"
					y2="677.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m231.47,677.11c0-1.09.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.45"
					y1="675.13"
					x2="275.41"
					y2="675.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m275.41,675.13c1.09,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.44"
					y1="682.07"
					x2="272.44"
					y2="734.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.46"
					y1="736.82"
					x2="243.36"
					y2="736.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.37"
					y1="734.84"
					x2="241.37"
					y2="682.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.36"
					y1="680.08"
					x2="270.46"
					y2="680.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.44"
					y1="682.07"
					x2="272.44"
					y2="682.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m272.44,734.84c0,1.09-.89,1.98-1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m243.36,736.82c-1.09,0-1.98-.89-1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m241.37,682.07c0-1.09.89-1.98,1.98-1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m270.46,680.08c1.09,0,1.98.89,1.98,1.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m254.25,708.45c0-1.64-1.33-2.97-2.97-2.97s-2.97,1.33-2.97,2.97,1.33,2.97,2.97,2.97,2.97-1.33,2.97-2.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="254.04 707.56 254.67 707.82 254.93 708.45 254.67 709.08 254.04 709.34 234.44 709.34 233.81 709.08 233.55 708.45 233.81 707.82 234.44 707.56 254.04 707.56"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m254.04,707.56c.49,0,.89.4.89.89s-.4.89-.89.89h0"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.04"
					y1="709.34"
					x2="234.44"
					y2="709.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m234.44,709.34c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.44"
					y1="707.56"
					x2="254.04"
					y2="707.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="239.49 706.47 239.49 707.56 234.44 707.56 233.81 707.82 233.55 708.45 233.81 709.08 234.44 709.34 239.49 709.34 239.49 710.43 233.05 710.43 233.05 706.47 239.49 706.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="239.49"
					y1="706.47"
					x2="239.49"
					y2="707.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.49"
					y1="707.56"
					x2="234.44"
					y2="707.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m234.44,709.34c-.49,0-.89-.4-.89-.89s.4-.89.89-.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.44"
					y1="709.34"
					x2="239.49"
					y2="709.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.49"
					y1="709.34"
					x2="239.49"
					y2="710.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.49"
					y1="710.43"
					x2="233.05"
					y2="710.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.05"
					y1="710.43"
					x2="233.05"
					y2="706.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.05"
					y1="706.47"
					x2="239.49"
					y2="706.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="243.06 706.5 243.06 707.56 239.59 707.56 239.59 706.5 243.06 706.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="243.06"
					y1="706.5"
					x2="243.06"
					y2="707.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.06"
					y1="707.56"
					x2="239.59"
					y2="707.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.59"
					y1="707.56"
					x2="239.59"
					y2="706.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.59"
					y1="706.5"
					x2="243.06"
					y2="706.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="243.06 710.4 239.59 710.4 239.59 709.34 243.06 709.34 243.06 710.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="243.06"
					y1="710.4"
					x2="239.59"
					y2="710.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.59"
					y1="710.4"
					x2="239.59"
					y2="709.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.59"
					y1="709.34"
					x2="243.06"
					y2="709.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.06"
					y1="709.34"
					x2="243.06"
					y2="710.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.3"
					y1="539.61"
					x2="720.69"
					y2="539.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.69"
					y1="539.61"
					x2="720.69"
					y2="587.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.3"
					y1="529.55"
					x2="738.3"
					y2="597.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.6"
					y1="597.49"
					x2="783.6"
					y2="529.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.6"
					y1="529.55"
					x2="715.65"
					y2="529.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.65"
					y1="597.49"
					x2="783.6"
					y2="597.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.91"
					y1="529.55"
					x2="716.91"
					y2="597.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.3"
					y1="587.43"
					x2="720.69"
					y2="587.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.65"
					y1="529.55"
					x2="715.65"
					y2="597.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.63"
					y1="606.83"
					x2="224.23"
					y2="606.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.31"
					y1="835.45"
					x2="336.31"
					y2="830.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.31"
					y1="830.48"
					x2="338.82"
					y2="830.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.82"
					y1="830.48"
					x2="338.82"
					y2="835.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="847.76"
					x2="416.74"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.11"
					y1="847.76"
					x2="407.08"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.45"
					y1="847.76"
					x2="397.41"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.79"
					y1="847.76"
					x2="387.75"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.13"
					y1="847.76"
					x2="378.09"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.46"
					y1="847.76"
					x2="368.42"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.8"
					y1="847.76"
					x2="358.76"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.14"
					y1="847.76"
					x2="349.1"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.48"
					y1="847.76"
					x2="339.43"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.81"
					y1="847.76"
					x2="333.79"
					y2="847.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.27"
					y1="70.14"
					x2="510.83"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.03"
					y1="70.14"
					x2="240.61"
					y2="70.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.58"
					y1="50"
					x2="404.06"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.44"
					y1="50"
					x2="582.3"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.05"
					y1="539.61"
					x2="776.05"
					y2="587.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.05"
					y1="587.43"
					x2="743.34"
					y2="587.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.34"
					y1="587.43"
					x2="743.34"
					y2="539.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.34"
					y1="539.61"
					x2="776.05"
					y2="539.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="877.96"
					x2="254.43"
					y2="874.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="871.03"
					x2="254.43"
					y2="864.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="861.37"
					x2="254.43"
					y2="855.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="851.7"
					x2="254.43"
					y2="845.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="842.04"
					x2="254.43"
					y2="836"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="832.38"
					x2="254.43"
					y2="826.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="822.71"
					x2="254.43"
					y2="816.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="813.05"
					x2="254.43"
					y2="807.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="803.39"
					x2="254.43"
					y2="797.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="793.73"
					x2="254.43"
					y2="787.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="784.06"
					x2="254.43"
					y2="778.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="774.4"
					x2="254.43"
					y2="768.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="764.74"
					x2="254.43"
					y2="758.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="755.07"
					x2="254.43"
					y2="749.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="745.41"
					x2="254.43"
					y2="739.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="735.75"
					x2="254.43"
					y2="729.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="726.09"
					x2="254.43"
					y2="720.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="716.42"
					x2="254.43"
					y2="710.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="706.76"
					x2="254.43"
					y2="700.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="697.1"
					x2="254.43"
					y2="691.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="687.43"
					x2="254.43"
					y2="681.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="677.77"
					x2="254.43"
					y2="671.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="668.11"
					x2="254.43"
					y2="662.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="658.44"
					x2="254.43"
					y2="652.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="648.78"
					x2="254.43"
					y2="642.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="639.12"
					x2="254.43"
					y2="633.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="629.46"
					x2="254.43"
					y2="623.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="619.79"
					x2="254.43"
					y2="613.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.43"
					y1="610.13"
					x2="254.43"
					y2="606.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="811.18 50 811.18 948.75 576.76 948.75 576.76 928.61 580.35 928.61 580.35 914.19 592.94 914.19 592.94 928.61 761.99 928.61 761.99 774.49 753.71 774.49 753.71 695.54 592.94 695.54 592.94 833.67 580.35 833.67 580.35 612.81 600.91 612.81 600.91 625.4 592.94 625.4 592.94 682.97 791.04 682.97 791.04 625.4 681.43 625.4 681.43 612.81 694.97 612.81 694.97 598.52 707.54 598.52 707.54 612.81 791.04 612.81 791.04 514.21 707.54 514.21 707.54 517.99 694.97 517.99 694.97 487.09 597.61 487.09 597.61 474.51 647.22 474.51 647.22 403.65 675.65 403.65 675.65 416.24 659.79 416.24 659.79 474.51 791.04 474.51 791.04 416.24 756.18 416.24 756.18 403.65 791.04 403.65 791.04 70.14 582.31 70.14 582.31 50 811.18 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
				<polygon
					points="517.08 474.51 517.08 487.09 492.85 487.09 492.85 151.47 438.15 151.47 438.15 70.14 404.07 70.14 404.07 50 505.44 50 505.44 474.51 517.08 474.51"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
				<polygon
					points="481.13 928.61 481.13 948.75 188.82 948.75 188.82 50 235.58 50 235.58 70.14 208.96 70.14 208.96 606.83 224.24 606.83 224.24 908.16 333.79 908.16 333.79 928.61 481.13 928.61"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
			</g>
			<g id="text">
				<path d="m372.59,889.03h-1.64l-1.97-3.29c-.18-.31-.36-.57-.52-.78-.17-.22-.34-.4-.52-.53-.17-.14-.37-.23-.57-.29-.2-.07-.43-.1-.69-.1h-1.13v5h-1.38v-11.75h3.51c.51,0,.99.07,1.42.2.44.13.81.32,1.13.58.32.26.57.59.75.98.18.39.27.84.27,1.37,0,.41-.06.79-.19,1.13-.12.34-.29.64-.52.91-.22.27-.5.5-.82.69-.32.19-.67.33-1.07.43v.03c.2.09.37.19.51.3.15.11.29.24.42.39.13.15.26.33.39.52.13.19.28.42.43.67l2.2,3.53Zm-7.05-10.5v4.26h1.87c.34,0,.66-.05.95-.16.29-.1.55-.25.76-.44.21-.2.38-.43.5-.71.12-.28.18-.6.18-.95,0-.63-.2-1.12-.61-1.47-.4-.36-.99-.53-1.76-.53h-1.88Zm15.07,6.65h-5.92c.02.93.27,1.66.75,2.16.48.51,1.14.76,1.98.76.95,0,1.81-.31,2.61-.93v1.26c-.74.54-1.71.8-2.93.8s-2.12-.38-2.79-1.14c-.68-.76-1.02-1.84-1.02-3.22,0-1.31.37-2.37,1.11-3.19.74-.82,1.66-1.24,2.76-1.24s1.95.35,2.55,1.07c.6.71.9,1.7.9,2.96v.7Zm-1.38-1.14c0-.78-.19-1.38-.57-1.81-.37-.43-.88-.65-1.53-.65s-1.17.23-1.61.68-.72,1.05-.82,1.78h4.53Zm7.4-6.24c-.26-.15-.56-.22-.89-.22-.94,0-1.41.59-1.41,1.78v1.29h1.97v1.15h-1.97v7.24h-1.34v-7.24h-1.43v-1.15h1.43v-1.36c0-.88.25-1.57.76-2.08.51-.51,1.14-.77,1.9-.77.41,0,.73.05.98.15v1.21Z" />
				<path d="m388.06,889.21c-.25,0-.47-.09-.65-.27-.17-.18-.26-.4-.26-.65s.09-.47.26-.65c.18-.19.4-.28.65-.28s.48.09.66.28c.18.18.27.4.27.65s-.09.47-.27.65c-.18.18-.4.27-.66.27Z" />
				<path d="m228.53,643.95v-11.67h4.02c.91,0,1.6.06,2.08.17.67.15,1.24.43,1.71.84.62.52,1.07,1.19,1.38,2,.31.81.46,1.73.46,2.77,0,.89-.1,1.67-.31,2.36-.21.68-.47,1.25-.8,1.7-.32.45-.68.8-1.07,1.06-.38.25-.85.45-1.39.58-.54.13-1.16.2-1.87.2h-4.21Zm1.54-1.38h2.49c.77,0,1.37-.07,1.81-.21.44-.14.79-.34,1.05-.6.37-.37.65-.86.85-1.47.21-.62.31-1.37.31-2.25,0-1.22-.2-2.16-.6-2.81-.4-.66-.88-1.1-1.46-1.32-.41-.16-1.08-.24-2-.24h-2.45v8.92Zm12.27,1.38l-3.1-11.67h1.58l1.78,7.65c.19.8.36,1.6.49,2.39.3-1.25.47-1.97.53-2.16l2.22-7.88h1.86l1.67,5.91c.42,1.46.72,2.84.91,4.13.15-.74.34-1.58.58-2.54l1.83-7.5h1.55l-3.2,11.67h-1.49l-2.46-8.89c-.21-.74-.33-1.2-.37-1.37-.12.54-.24.99-.34,1.37l-2.48,8.89h-1.58Z" />
				<path d="m248.74,336.71h-9.46v-18.24h2.14v16.3h7.33v1.93Zm3.59-16.33c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.97s.13-.71.39-.97c.26-.26.58-.39.95-.39s.7.13.97.39c.27.25.41.58.41.97s-.14.69-.41.95c-.26.26-.58.39-.97.39Zm1.02,16.33h-2.09v-13.02h2.09v13.02Zm14.45-13.02l-5.19,13.02h-2.05l-4.93-13.02h2.29l3.31,9.46c.25.7.4,1.3.46,1.82h.05c.08-.65.22-1.24.41-1.77l3.46-9.51h2.2Zm3.3-3.31c-.37,0-.69-.13-.95-.38s-.39-.58-.39-.97.13-.71.39-.97c.26-.26.58-.39.95-.39s.7.13.97.39c.27.25.41.58.41.97s-.14.69-.41.95c-.26.26-.58.39-.97.39Zm1.02,16.33h-2.09v-13.02h2.09v13.02Zm15.02,0h-2.09v-7.43c0-2.76-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.59,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.02h2.09v2.16h.05c.98-1.64,2.41-2.47,4.27-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Zm15.04-1.04c0,4.78-2.29,7.17-6.87,7.17-1.61,0-3.02-.31-4.22-.92v-2.09c1.47.81,2.87,1.22,4.2,1.22,3.2,0,4.81-1.7,4.81-5.11v-1.42h-.05c-.99,1.66-2.48,2.49-4.48,2.49-1.62,0-2.93-.58-3.92-1.73-.98-1.16-1.48-2.72-1.48-4.67,0-2.21.53-3.97,1.59-5.28,1.07-1.31,2.53-1.96,4.37-1.96s3.06.7,3.9,2.11h.05v-1.81h2.09v11.98Zm-2.09-4.85v-1.92c0-1.03-.35-1.92-1.06-2.66-.7-.74-1.56-1.11-2.61-1.11-1.29,0-2.3.47-3.03,1.41-.73.93-1.09,2.24-1.09,3.93,0,1.45.35,2.61,1.04,3.48.7.86,1.63,1.3,2.79,1.3s2.12-.42,2.85-1.25c.74-.83,1.11-1.89,1.11-3.19Z" />
				<polygon points="314.62 318.47 305.87 339.73 303.92 339.73 312.64 318.47 314.62 318.47" />
				<path d="m316.74,336.71v-18.24h5.04c6.43,0,9.64,2.96,9.64,8.89,0,2.81-.89,5.08-2.68,6.79-1.78,1.7-4.17,2.56-7.16,2.56h-4.83Zm2.14-16.3v14.37h2.72c2.39,0,4.25-.64,5.58-1.92,1.33-1.28,2-3.09,2-5.44,0-4.67-2.48-7.01-7.45-7.01h-2.85Zm16.84-.03c-.37,0-.69-.13-.95-.38-.26-.25-.39-.58-.39-.97s.13-.71.39-.97c.26-.26.58-.39.95-.39s.7.13.97.39c.27.25.41.58.41.97s-.14.69-.41.95c-.26.26-.59.39-.97.39Zm1.02,16.33h-2.09v-13.02h2.09v13.02Zm14.95,0h-2.09v-7.43c0-2.76-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.59,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.02h2.09v2.16h.05c.98-1.64,2.41-2.47,4.27-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Zm4.92-16.33c-.37,0-.69-.13-.95-.38s-.39-.58-.39-.97.13-.71.39-.97c.26-.26.58-.39.95-.39s.7.13.97.39c.27.25.41.58.41.97s-.14.69-.41.95c-.26.26-.59.39-.97.39Zm1.02,16.33h-2.09v-13.02h2.09v13.02Zm14.95,0h-2.09v-7.43c0-2.76-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.59,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.02h2.09v2.16h.05c.98-1.64,2.41-2.47,4.27-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Zm14.97-1.04c0,4.78-2.29,7.17-6.87,7.17-1.61,0-3.02-.31-4.22-.92v-2.09c1.47.81,2.87,1.22,4.2,1.22,3.2,0,4.81-1.7,4.81-5.11v-1.42h-.05c-.99,1.66-2.48,2.49-4.48,2.49-1.62,0-2.93-.58-3.92-1.73-.98-1.16-1.48-2.72-1.48-4.67,0-2.21.53-3.97,1.59-5.28,1.07-1.31,2.53-1.96,4.37-1.96s3.06.7,3.9,2.11h.05v-1.81h2.09v11.98Zm-2.09-4.85v-1.92c0-1.03-.35-1.92-1.06-2.66-.7-.74-1.56-1.11-2.61-1.11-1.29,0-2.3.47-3.03,1.41-.73.93-1.09,2.24-1.09,3.93,0,1.45.35,2.61,1.04,3.48.7.86,1.63,1.3,2.79,1.3s2.12-.42,2.85-1.25c.74-.83,1.11-1.89,1.11-3.19Z" />
				<path d="m412.49,336.71h-2.54l-3.05-5.11c-.28-.47-.55-.88-.81-1.21-.26-.34-.53-.61-.81-.83-.27-.21-.57-.36-.89-.46-.31-.1-.67-.15-1.07-.15h-1.76v7.76h-2.14v-18.24h5.44c.8,0,1.53.1,2.2.31.68.19,1.26.5,1.76.9.5.41.89.92,1.17,1.53.28.6.42,1.31.42,2.12,0,.64-.1,1.22-.29,1.76-.19.53-.46,1-.81,1.41-.35.42-.77.77-1.27,1.07-.49.29-1.05.51-1.67.67v.05c.31.14.57.29.79.47.23.17.45.37.65.61.2.24.4.51.6.81.2.3.43.64.67,1.04l3.42,5.48Zm-10.94-16.3v6.61h2.9c.53,0,1.03-.08,1.48-.24.46-.16.85-.39,1.18-.69.33-.31.59-.67.78-1.11.19-.44.28-.93.28-1.48,0-.98-.32-1.73-.95-2.28-.63-.55-1.54-.83-2.73-.83h-2.93Zm18.53,16.61c-1.92,0-3.46-.61-4.62-1.82-1.14-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13s2.81-1.84,4.85-1.84,3.45.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.76s.39,2.76,1.18,3.65c.79.89,1.84,1.34,3.17,1.34s2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.76c-.72-.88-1.76-1.32-3.1-1.32Zm15.03,11.88c-1.92,0-3.46-.61-4.62-1.82-1.14-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13,1.2-1.23,2.81-1.84,4.85-1.84s3.45.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.76s.39,2.76,1.18,3.65c.79.89,1.84,1.34,3.17,1.34s2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.76c-.72-.88-1.76-1.32-3.1-1.32Zm28.08,11.57h-2.09v-7.48c0-1.44-.22-2.48-.67-3.13-.44-.64-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.81-.93,1.79-.93,2.93v7.43h-2.09v-7.73c0-2.56-.99-3.84-2.96-3.84-.92,0-1.67.39-2.26,1.16-.59.76-.89,1.76-.89,2.99v7.43h-2.09v-13.02h2.09v2.06h.05c.92-1.58,2.27-2.37,4.04-2.37.89,0,1.67.25,2.33.75.66.49,1.11,1.14,1.36,1.95.97-1.8,2.41-2.7,4.32-2.7,2.87,0,4.3,1.77,4.3,5.3v8.02Z" />
				<path d="m313.33,356.31c0,1.21-.12,2.3-.36,3.25-.24.94-.59,1.75-1.05,2.41-.46.65-1.03,1.15-1.69,1.5-.67.34-1.42.51-2.28.51s-1.65-.15-2.31-.46v-1.45c.73.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.47-.25.88-.6,1.2-1.07.33-.47.58-1.06.75-1.75.17-.69.26-1.48.26-2.38h-.04c-.57,1.14-1.55,1.71-2.96,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.8-1.31s-.29-1.06-.29-1.67c0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.4.38-.39.83-.7,1.35-.92.52-.22,1.09-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.3,1.17.35.51.62,1.14.8,1.9.18.75.28,1.61.28,2.58Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.02.22c-.31.14-.59.35-.82.61-.23.26-.41.57-.55.93-.13.36-.19.75-.19,1.17,0,.47.06.89.19,1.26.13.37.31.68.55.94.23.25.51.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.59-.31.81-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="315.79" y="350.48" width="1.34" height="4.14" />
				<path d="m328.03,359.53c0,.65-.1,1.24-.31,1.79-.21.54-.5,1.01-.87,1.41-.37.39-.81.7-1.32.93-.51.22-1.07.32-1.67.32-.67,0-1.26-.14-1.79-.42-.52-.28-.97-.68-1.34-1.19-.36-.52-.64-1.16-.83-1.91s-.29-1.6-.29-2.54c0-1.15.13-2.2.38-3.14.26-.94.62-1.75,1.09-2.41.47-.67,1.05-1.19,1.71-1.55s1.41-.55,2.23-.55c.91,0,1.65.13,2.2.38v1.43c-.68-.35-1.41-.53-2.16-.53-.59,0-1.13.13-1.6.4-.47.27-.88.64-1.22,1.13-.34.48-.6,1.06-.79,1.75-.18.68-.27,1.45-.27,2.29h.04c.61-1.1,1.62-1.66,3.03-1.66.58,0,1.1.1,1.56.3.47.2.87.48,1.19.84.33.36.59.79.77,1.29.18.5.27,1.05.27,1.67Zm-1.55.19c0-.46-.06-.88-.18-1.25-.12-.37-.29-.68-.51-.94-.22-.26-.48-.46-.8-.59-.32-.14-.68-.21-1.09-.21-.38,0-.72.07-1.05.21-.32.14-.6.34-.83.58-.23.24-.42.52-.56.85-.13.32-.19.66-.19,1.03,0,.46.06.89.19,1.29.13.39.31.74.55,1.04.23.3.51.53.83.7.33.17.69.25,1.08.25s.73-.07,1.05-.21c.31-.15.58-.35.8-.61s.39-.57.52-.93c.12-.36.19-.76.19-1.2Z" />
				<path d="m331.65,350.48v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m349.89,354.27l-3.18,4.79,3.13,4.68h-1.77l-1.86-3.07c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.43.72l-1.9,3.07h-1.75l3.23-4.64-3.09-4.83h1.77l1.83,3.24c.14.24.27.49.4.74h.04l2.37-3.98h1.67Z" />
				<path d="m362.03,363.74h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Zm12.88-12.39c-.2.35-.45.79-.74,1.31-.28.52-.59,1.11-.91,1.77-.32.65-.65,1.36-.98,2.11-.33.75-.64,1.53-.93,2.33-.29.8-.55,1.62-.77,2.44-.22.82-.37,1.63-.47,2.42h-1.63c.11-.79.28-1.59.51-2.41.23-.83.5-1.63.79-2.42.3-.8.61-1.56.93-2.29.33-.73.64-1.41.95-2.03.31-.62.59-1.16.84-1.63.26-.47.47-.84.62-1.11h-6.65v-1.37h8.44v.88Z" />
				<rect x="377.3" y="350.48" width="1.34" height="4.14" />
				<path d="m389.38,356.31c0,1.21-.12,2.3-.36,3.25-.24.94-.59,1.75-1.05,2.41-.46.65-1.03,1.15-1.69,1.5-.67.34-1.42.51-2.28.51s-1.65-.15-2.31-.46v-1.45c.73.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.47-.25.88-.6,1.2-1.07.33-.47.58-1.06.75-1.75.17-.69.26-1.48.26-2.38h-.04c-.57,1.14-1.55,1.71-2.96,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.88-.49-1.23-.85-.35-.37-.61-.81-.8-1.31s-.29-1.06-.29-1.67c0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.4.38-.39.83-.7,1.35-.92.52-.22,1.09-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.3,1.17.35.51.62,1.14.8,1.9.19.75.28,1.61.28,2.58Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.02.22c-.31.14-.59.35-.82.61-.23.26-.41.57-.55.93-.13.36-.19.75-.19,1.17,0,.47.06.89.19,1.26.13.37.31.68.55.94.23.25.52.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.59-.31.81-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<path d="m393.17,350.48v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m597.75,235.12v-18.24h5.19c1.58,0,2.83.39,3.75,1.16.92.77,1.39,1.78,1.39,3.01,0,1.03-.28,1.93-.84,2.7-.56.76-1.33,1.31-2.31,1.63v.05c1.23.14,2.21.61,2.95,1.4.74.78,1.11,1.8,1.11,3.05,0,1.56-.56,2.82-1.68,3.79-1.12.97-2.53,1.45-4.23,1.45h-5.32Zm2.14-16.3v5.89h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1-1.37,1-2.39,0-1.77-1.17-2.66-3.5-2.66h-2.45Zm0,7.81v6.56h2.9c1.25,0,2.23-.3,2.91-.89.7-.59,1.04-1.41,1.04-2.44,0-2.15-1.47-3.23-4.4-3.23h-2.45Zm22.96,2.51h-9.19c.03,1.45.42,2.57,1.17,3.36s1.77,1.18,3.08,1.18c1.47,0,2.81-.48,4.04-1.45v1.96c-1.14.83-2.66,1.25-4.54,1.25s-3.29-.59-4.34-1.77c-1.05-1.19-1.58-2.85-1.58-5,0-2.03.57-3.68,1.72-4.95,1.15-1.28,2.58-1.92,4.29-1.92s3.02.55,3.96,1.65,1.4,2.63,1.4,4.59v1.09Zm-2.14-1.77c0-1.2-.3-2.14-.88-2.81-.57-.67-1.36-1-2.38-1s-1.82.35-2.51,1.06c-.69.7-1.11,1.62-1.27,2.76h7.03Zm16.39,7.76h-2.09v-2.21h-.05c-.97,1.68-2.46,2.52-4.48,2.52-1.64,0-2.95-.58-3.93-1.74-.98-1.17-1.46-2.76-1.46-4.77,0-2.15.54-3.88,1.63-5.18,1.09-1.3,2.53-1.95,4.34-1.95s3.09.7,3.9,2.11h.05v-8.06h2.09v19.28Zm-2.09-5.89v-1.92c0-1.05-.35-1.94-1.04-2.67-.7-.73-1.58-1.09-2.65-1.09-1.27,0-2.27.47-3,1.4-.73.93-1.09,2.22-1.09,3.87,0,1.5.35,2.69,1.04,3.56.7.86,1.64,1.3,2.82,1.3s2.1-.42,2.82-1.26c.73-.84,1.09-1.9,1.09-3.18Zm13.08-5.02c-.36-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.98-.89,3.43v6.64h-2.09v-13.02h2.09v2.68h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.29-.78,2.05-.78.54,0,.96.06,1.25.18v2.16Zm7.7,11.22c-1.92,0-3.46-.61-4.62-1.82-1.14-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13s2.81-1.84,4.85-1.84,3.45.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.76s.39,2.76,1.18,3.65,1.84,1.34,3.17,1.34,2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.76c-.72-.88-1.76-1.32-3.1-1.32Zm15.09,11.88c-1.92,0-3.46-.61-4.62-1.82-1.14-1.22-1.72-2.84-1.72-4.85,0-2.19.6-3.9,1.79-5.13,1.2-1.23,2.81-1.84,4.85-1.84s3.45.6,4.54,1.79c1.09,1.2,1.64,2.85,1.64,4.97s-.59,3.74-1.77,5c-1.17,1.25-2.74,1.87-4.72,1.87Zm.15-11.88c-1.34,0-2.4.46-3.18,1.37-.78.91-1.17,2.16-1.17,3.76s.39,2.76,1.18,3.65,1.84,1.34,3.17,1.34,2.38-.44,3.1-1.31c.73-.87,1.09-2.12,1.09-3.73s-.36-2.88-1.09-3.76c-.72-.88-1.76-1.32-3.1-1.32Zm28.14,11.57h-2.09v-7.48c0-1.44-.22-2.48-.67-3.13-.44-.64-1.19-.97-2.24-.97-.89,0-1.65.41-2.28,1.22-.62.81-.93,1.79-.93,2.93v7.43h-2.09v-7.73c0-2.56-.99-3.84-2.96-3.84-.92,0-1.67.39-2.26,1.16-.59.76-.89,1.76-.89,2.99v7.43h-2.09v-13.02h2.09v2.06h.05c.92-1.58,2.27-2.37,4.04-2.37.89,0,1.67.25,2.33.75.66.49,1.11,1.14,1.36,1.95.97-1.8,2.41-2.7,4.32-2.7,2.87,0,4.3,1.77,4.3,5.3v8.02Z" />
				<path d="m610.67,254.73c0,1.21-.12,2.3-.36,3.25-.24.94-.59,1.75-1.05,2.41-.46.65-1.03,1.15-1.69,1.5-.67.34-1.42.51-2.28.51s-1.65-.15-2.31-.46v-1.45c.73.41,1.52.62,2.35.62.6,0,1.13-.12,1.6-.37.47-.25.88-.6,1.2-1.07.33-.47.58-1.06.75-1.75.17-.69.26-1.48.26-2.38h-.04c-.57,1.14-1.55,1.71-2.96,1.71-.57,0-1.09-.1-1.56-.3-.47-.2-.89-.49-1.23-.85-.35-.37-.61-.81-.8-1.31-.19-.51-.29-1.06-.29-1.67,0-.65.1-1.25.31-1.79.22-.54.51-1.01.89-1.4.38-.39.83-.7,1.35-.92.52-.22,1.09-.32,1.71-.32.67,0,1.26.14,1.77.41.52.27.95.66,1.3,1.17.35.51.62,1.14.8,1.9s.28,1.61.28,2.58Zm-1.64-1.36c0-.51-.07-.98-.2-1.4-.13-.42-.31-.78-.55-1.07-.23-.3-.51-.53-.84-.69-.32-.17-.67-.25-1.05-.25s-.7.07-1.02.22c-.31.14-.59.35-.82.61-.23.26-.41.57-.55.93-.13.36-.19.75-.19,1.17,0,.47.06.89.19,1.26.13.37.31.68.55.94.23.25.51.45.84.58.33.14.7.2,1.1.2.35,0,.68-.06.99-.19.31-.14.59-.31.81-.54.23-.23.42-.49.55-.8.14-.31.2-.64.2-.99Z" />
				<rect x="613.12" y="248.89" width="1.34" height="4.14" />
				<path d="m625.36,257.95c0,.65-.1,1.24-.31,1.79s-.5,1.01-.87,1.41c-.37.39-.81.7-1.32.93-.51.22-1.07.32-1.67.32-.67,0-1.26-.14-1.79-.42-.52-.28-.97-.68-1.34-1.19-.36-.52-.64-1.16-.83-1.91s-.29-1.6-.29-2.54c0-1.15.13-2.2.38-3.14.26-.94.62-1.75,1.09-2.41.47-.67,1.05-1.19,1.71-1.55s1.41-.55,2.23-.55c.91,0,1.65.13,2.2.38v1.43c-.68-.35-1.41-.53-2.16-.53-.59,0-1.13.13-1.6.4-.47.27-.88.64-1.22,1.13-.34.48-.6,1.06-.79,1.75-.18.68-.27,1.45-.27,2.29h.04c.61-1.1,1.62-1.66,3.03-1.66.58,0,1.1.1,1.56.3.47.2.87.48,1.19.84.33.36.59.79.77,1.29.18.5.27,1.05.27,1.67Zm-1.55.19c0-.46-.06-.88-.18-1.25-.12-.37-.29-.68-.51-.94-.22-.26-.48-.46-.8-.59-.32-.14-.68-.21-1.09-.21-.38,0-.72.07-1.05.21s-.6.34-.83.58c-.23.24-.42.52-.56.85-.13.32-.19.66-.19,1.03,0,.46.06.88.19,1.29.13.39.31.74.55,1.04.23.3.51.53.83.7.33.17.69.25,1.08.25s.73-.07,1.05-.21c.31-.15.58-.35.8-.61s.39-.57.52-.93c.12-.36.19-.76.19-1.2Z" />
				<path d="m628.99,248.89v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m647.22,252.68l-3.18,4.79,3.13,4.68h-1.77l-1.86-3.07c-.12-.19-.26-.43-.42-.72h-.04c-.03.06-.18.3-.43.72l-1.9,3.07h-1.75l3.23-4.64-3.09-4.83h1.77l1.83,3.24c.14.24.27.49.4.74h.04l2.37-3.98h1.67Z" />
				<path d="m659.36,262.16h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Zm10.23,0h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Z" />
				<rect x="674.63" y="248.89" width="1.34" height="4.14" />
				<path d="m684.12,262.16h-1.52v-11.46c-.12.12-.29.25-.52.41-.22.15-.47.3-.76.44-.28.15-.57.29-.89.42-.31.13-.61.23-.91.31v-1.54c.33-.09.68-.22,1.05-.37.38-.16.74-.34,1.1-.53.36-.2.71-.4,1.03-.61.32-.22.6-.43.83-.63h.57v13.56Z" />
				<path d="m690.5,248.89v4.14h-1.34v-4.14h1.34Zm3.07,0v4.14h-1.34v-4.14h1.34Z" />
				<path d="m324.14,732h-2.98l-7.05-8.34c-.26-.31-.42-.53-.48-.64h-.05v8.98h-2.14v-18.24h2.14v8.57h.05c.12-.19.28-.39.48-.62l6.82-7.95h2.66l-7.82,8.75,8.37,9.49Zm3.19-16.33c-.37,0-.69-.13-.95-.38s-.39-.58-.39-.97.13-.71.39-.97c.26-.26.58-.39.95-.39s.7.13.97.39c.27.25.41.58.41.97s-.14.69-.41.95c-.26.26-.59.39-.97.39Zm1.02,16.33h-2.09v-13.02h2.09v13.02Zm10.24-.13c-.49.27-1.14.41-1.95.41-2.28,0-3.42-1.27-3.42-3.82v-7.71h-2.24v-1.78h2.24v-3.18l2.09-.67v3.85h3.28v1.78h-3.28v7.34c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm11.65-.47c-1,.6-2.19.9-3.56.9-1.86,0-3.36-.6-4.5-1.81-1.14-1.21-1.7-2.78-1.7-4.71,0-2.15.61-3.87,1.84-5.16,1.23-1.31,2.87-1.96,4.92-1.96,1.14,0,2.15.21,3.03.64v2.14c-.97-.68-2-1.02-3.1-1.02-1.33,0-2.42.48-3.28,1.44-.85.95-1.27,2.2-1.27,3.75s.4,2.73,1.2,3.61c.81.88,1.88,1.32,3.23,1.32,1.14,0,2.2-.38,3.2-1.13v1.98Zm13.95.6h-2.09v-7.5c0-2.71-1.01-4.07-3.03-4.07-1.02,0-1.87.39-2.57,1.18-.7.78-1.04,1.78-1.04,3.01v7.38h-2.09v-19.28h2.09v8.42h.05c1-1.64,2.42-2.47,4.27-2.47,2.93,0,4.4,1.77,4.4,5.3v8.02Zm14.38-5.99h-9.19c.03,1.45.42,2.57,1.17,3.36.75.79,1.77,1.18,3.08,1.18,1.47,0,2.81-.48,4.04-1.45v1.96c-1.14.83-2.66,1.25-4.54,1.25s-3.29-.59-4.34-1.77c-1.05-1.19-1.58-2.85-1.58-5,0-2.03.57-3.68,1.72-4.95,1.15-1.28,2.58-1.92,4.29-1.92s3.02.55,3.96,1.65c.93,1.1,1.4,2.63,1.4,4.59v1.09Zm-2.14-1.77c0-1.2-.3-2.14-.88-2.81-.57-.67-1.36-1-2.38-1s-1.82.35-2.51,1.06c-.69.7-1.11,1.62-1.27,2.76h7.03Zm16.09,7.76h-2.09v-7.43c0-2.76-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.59,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.02h2.09v2.16h.05c.98-1.64,2.41-2.47,4.27-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Z" />
				<path d="m482.35,837.91h-9.67v-18.24h9.26v1.93h-7.12v6.07h6.59v1.92h-6.59v6.38h7.53v1.93Zm14.07,0h-2.09v-7.43c0-2.76-1.01-4.15-3.03-4.15-1.04,0-1.91.39-2.59,1.18-.68.78-1.02,1.77-1.02,2.96v7.43h-2.09v-13.02h2.09v2.16h.05c.98-1.64,2.41-2.47,4.27-2.47,1.42,0,2.51.46,3.27,1.39.75.92,1.13,2.24,1.13,3.98v7.96Zm10-.13c-.49.27-1.14.41-1.95.41-2.28,0-3.42-1.27-3.42-3.82v-7.71h-2.24v-1.78h2.24v-3.18l2.09-.67v3.85h3.28v1.78h-3.28v7.34c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm9.6-10.78c-.36-.28-.89-.42-1.58-.42-.89,0-1.64.42-2.24,1.26-.59.84-.89,1.98-.89,3.43v6.64h-2.09v-13.02h2.09v2.68h.05c.3-.92.75-1.63,1.36-2.14.61-.52,1.29-.78,2.05-.78.54,0,.96.06,1.25.18v2.16Zm12.66-2.11l-5.99,15.11c-1.07,2.7-2.57,4.04-4.5,4.04-.54,0-1-.06-1.36-.17v-1.87c.45.15.86.23,1.23.23,1.05,0,1.84-.63,2.37-1.88l1.04-2.47-5.09-13h2.31l3.52,10.02c.04.13.13.46.27.99h.08c.04-.2.13-.53.25-.97l3.7-10.05h2.16Z" />
				<path d="m628.82,825.16v-18.24h5.19c1.58,0,2.83.39,3.75,1.16.92.77,1.39,1.78,1.39,3.01,0,1.03-.28,1.93-.84,2.7-.56.76-1.33,1.31-2.31,1.63v.05c1.23.14,2.21.61,2.95,1.4.74.78,1.11,1.8,1.11,3.05,0,1.56-.56,2.82-1.68,3.79-1.12.97-2.53,1.45-4.23,1.45h-5.32Zm2.14-16.3v5.89h2.19c1.17,0,2.09-.28,2.76-.84.67-.57,1-1.37,1-2.39,0-1.77-1.17-2.66-3.5-2.66h-2.45Zm0,7.81v6.56h2.9c1.25,0,2.23-.3,2.91-.89.7-.59,1.04-1.41,1.04-2.44,0-2.15-1.47-3.23-4.4-3.23h-2.45Zm21.83,8.5h-2.09v-2.03h-.05c-.91,1.56-2.24,2.34-4.01,2.34-1.3,0-2.31-.34-3.05-1.03-.73-.69-1.09-1.6-1.09-2.73,0-2.43,1.43-3.85,4.3-4.25l3.9-.55c0-2.21-.89-3.32-2.68-3.32-1.57,0-2.98.53-4.25,1.6v-2.14c1.28-.81,2.76-1.22,4.43-1.22,3.06,0,4.59,1.62,4.59,4.86v8.47Zm-2.09-6.59l-3.14.43c-.97.14-1.7.38-2.19.72-.49.34-.74.95-.74,1.82,0,.64.22,1.16.67,1.56.46.4,1.06.6,1.82.6,1.03,0,1.89-.36,2.56-1.08.68-.73,1.02-1.65,1.02-2.76v-1.3Zm12.06,6.46c-.49.27-1.14.41-1.95.41-2.28,0-3.42-1.27-3.42-3.82v-7.71h-2.24v-1.78h2.24v-3.18l2.09-.67v3.85h3.28v1.78h-3.28v7.34c0,.87.15,1.5.45,1.87.3.37.79.56,1.48.56.53,0,.98-.14,1.36-.43v1.78Zm13.6.13h-2.09v-7.5c0-2.71-1.01-4.07-3.03-4.07-1.02,0-1.87.39-2.57,1.18-.7.78-1.04,1.78-1.04,3.01v7.38h-2.09v-19.28h2.09v8.42h.05c1-1.64,2.42-2.47,4.27-2.47,2.93,0,4.4,1.77,4.4,5.3v8.02Z" />
				<path d="m758.23,558.82l-3.28,11.6h-1.59l-2.39-8.48c-.1-.36-.16-.76-.19-1.18h-.03c-.03.4-.1.79-.21,1.17l-2.4,8.5h-1.58l-3.4-11.6h1.5l2.47,8.9c.1.37.17.76.19,1.17h.04c.03-.29.11-.67.25-1.17l2.57-8.9h1.3l2.46,8.97c.09.31.15.67.19,1.08h.03c.02-.28.09-.65.22-1.12l2.37-8.93h1.47Z" />
				<polygon points="765 558.82 759.43 572.35 758.19 572.35 763.74 558.82 765 558.82" />
				<path d="m766.35,570.43v-11.6h3.2c4.09,0,6.13,1.89,6.13,5.66,0,1.79-.57,3.23-1.71,4.32-1.13,1.08-2.65,1.63-4.56,1.63h-3.07Zm1.36-10.37v9.14h1.73c1.52,0,2.71-.41,3.55-1.22.85-.81,1.27-1.97,1.27-3.46,0-2.97-1.58-4.46-4.74-4.46h-1.81Z" />
			</g>
		</g>
	)
}

export default PlanJ
